export const validators = {
	data() {
		return {
			validators: {
				comment: {
					required: true,
				},
				contractDate: {
					required: true,
				},
				contractNumber: {
					required: true,
				},
				type:{
					required: true,
				},
				contragentId: {
					required: true,
				},
				contragentName: {
					required: true,
				},
				responsibleId: {
					required: true,
				},
				responsibleName: {
					required: true,
				},
				stageId: {
					required: true,
				},
				stageName: {
					required: true,
				},
				priceUsd: {
					required: true,
				},
				priceUzs: {
					required: true,
				},
				completed: {
					required: true,
				},


			}
		}
	},

	methods: {
		checkField(name) {
			const valid = Object.keys(this.validationFields).some(() =>  this.validationFields[name].valid );
			const invalid = Object.keys(this.validationFields).some(() =>  this.validationFields[name].invalid );
			const touched = Object.keys(this.validationFields).some(() =>  this.validationFields[name].touched );
			const changed = Object.keys(this.validationFields).some(() =>  this.validationFields[name].changed );
			if (( touched) && valid) {
				return true;
			}
			if ((touched) && !valid) {
				return false
			}
			if ((changed) && invalid) {
				return false
			}

			return null
		}
	}
};
